
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("dUGrL"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("dUGrL", function(module, exports) {

let $029d2f330f431ffa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $029d2f330f431ffa$var$load("h3ABO"),
    $029d2f330f431ffa$var$load("djHM5"),
    $029d2f330f431ffa$var$load("eJQji"),
    $029d2f330f431ffa$var$load("2YffH"),
    $029d2f330f431ffa$var$load("6mHrv"),
    $029d2f330f431ffa$var$load("awWN9"),
    $029d2f330f431ffa$var$load("9CYct"),
    $029d2f330f431ffa$var$load("jyPfp"),
    $029d2f330f431ffa$var$load("lwJSr"),
    $029d2f330f431ffa$var$load("hZtKG"),
    $029d2f330f431ffa$var$load("iNmaF"),
    $029d2f330f431ffa$var$load("lVO3w"),
    $029d2f330f431ffa$var$load("hyzoX"),
    $029d2f330f431ffa$var$load("h9Ed7"),
    $029d2f330f431ffa$var$load("eBRUf"),
    $029d2f330f431ffa$var$load("kbRvk"),
    $029d2f330f431ffa$var$load("tKhaz"),
    $029d2f330f431ffa$var$load("k8QRJ"),
    $029d2f330f431ffa$var$load("43bfx"),
    $029d2f330f431ffa$var$load("cD6Zr"),
    $029d2f330f431ffa$var$load("fPSgL"),
    $029d2f330f431ffa$var$load("aDOZ4"),
    $029d2f330f431ffa$var$load("9wzNh"),
    $029d2f330f431ffa$var$load("8YSo7"),
    $029d2f330f431ffa$var$load("3Zfzp"),
    $029d2f330f431ffa$var$load("9ldRJ"),
    $029d2f330f431ffa$var$load("9anPW"),
    $029d2f330f431ffa$var$load("50ame"),
    $029d2f330f431ffa$var$load("eYWAR"),
    $029d2f330f431ffa$var$load("8z2kq"),
    $029d2f330f431ffa$var$load("ebWFc"),
    $029d2f330f431ffa$var$load("g9CVe"),
    $029d2f330f431ffa$var$load("6iz6l"),
    $029d2f330f431ffa$var$load("4SCW2"),
    $029d2f330f431ffa$var$load("855o0"),
    $029d2f330f431ffa$var$load("8MfZE"),
    $029d2f330f431ffa$var$load("hv4mn"),
    $029d2f330f431ffa$var$load("Wowvf"),
    $029d2f330f431ffa$var$load("dek7I"),
    $029d2f330f431ffa$var$load("dYtBN"),
    $029d2f330f431ffa$var$load("6wr18"),
    $029d2f330f431ffa$var$load("kjZZD"),
    $029d2f330f431ffa$var$load("2zxmz"),
    $029d2f330f431ffa$var$load("7269o"),
    $029d2f330f431ffa$var$load("6iJPF"),
    $029d2f330f431ffa$var$load("lB2B1"),
    $029d2f330f431ffa$var$load("37ldp"),
    $029d2f330f431ffa$var$load("ffEVr"),
    $029d2f330f431ffa$var$load("dRpV3"),
    $029d2f330f431ffa$var$load("dTsOE"),
    $029d2f330f431ffa$var$load("hhss7"),
    $029d2f330f431ffa$var$load("jwTn5"),
    $029d2f330f431ffa$var$load("aYdgM"),
    $029d2f330f431ffa$var$load("jY21r"),
    $029d2f330f431ffa$var$load("8fMw3"),
    $029d2f330f431ffa$var$load("hogcU"),
    $029d2f330f431ffa$var$load("hcSzd"),
    $029d2f330f431ffa$var$load("cSBzF"),
    $029d2f330f431ffa$var$load("7EorR"),
    $029d2f330f431ffa$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.6b5b634c.js.map
